export default {
  MESSAGES: {
    FAILED_PROCESS_ADMIN:
      'Failed to process request, please contact your administrator',
    FAILED_GET: 'Failed to fetch data from the server',
    FAILED_CHECKOUT: 'Failed to create an invoice for your cart.',
    REQUIRED_FIELD: 'This field is required',
    FILL_ALL_FIELD: 'Please fill all required fields',
    INVOICE_PROCESSED: 'Invoice has been processed',
    CHECK_CONNECTION: 'Please check your internet connection, or contact support.'
  }
}
